import React, { createContext, useContext, useState, useEffect } from "react";

export const translations = {
  es: {
    nav: {
      services: "Servicios",
      process: "Cómo funciona",
      results: "Resultados",
      faq: "Preguntas",
      contact: "Contacto",
      bookDemo: "Reservar demo",
      bookShort: "Reservar",
    },
    hero: {
      eyebrow: "Agencia de automatización con IA",
      title1: "Tu clínica dental,",
      title2: "siempre llena.",
      subtitle:
        "Ayudamos a clínicas dentales a recuperar miles de euros al mes evitando cancelaciones, no-shows y reactivando pacientes inactivos.",
      ctaPrimary: "Reserva una demo gratuita",
      ctaSecondary: "Ver servicios",
      microPoint1: "Sin permanencia",
      microPoint2: "Implementación en 7 días",
      microPoint3: "Soporte en español",
    },
    stats: {
      eyebrow: "Resultados medibles",
      title: "Diseñado para generar retorno desde el primer mes.",
      items: [
        { value: "+47%", label: "Pacientes recuperados" },
        { value: "−68%", label: "Citas no asistidas" },
        { value: "24/7", label: "Atención automática" },
        { value: "5×", label: "ROI promedio" },
      ],
    },
    services: {
      eyebrow: "Servicios",
      title: "Tres sistemas. Una clínica que funciona sola.",
      subtitle:
        "Integramos cada solución con tu software de gestión actual. Sin migraciones complicadas.",
      items: [
        {
          tag: "01",
          name: "Chatbot IA",
          short: "Atiende WhatsApp y web 24/7.",
          desc: "Un asistente entrenado para tu clínica que responde preguntas frecuentes, califica pacientes y agenda citas automáticamente.",
          bullets: [
            "Integración con WhatsApp Business",
            "Reservas automáticas",
            "Traspaso a humano cuando hace falta",
          ],
        },
        {
          tag: "02",
          name: "Automatización de citas",
          short: "Recordatorios que reducen las ausencias.",
          desc: "Confirmaciones, recordatorios y reprogramaciones inteligentes por SMS, email y WhatsApp. Olvídate del hueco en la agenda.",
          bullets: [
            "Recordatorios multicanal",
            "Confirmación con un clic",
            "Reagenda automática",
          ],
        },
        {
          tag: "03",
          name: "Recuperación de pacientes",
          short: "Vuelve a llenar tu agenda con quien ya te conoce.",
          desc: "Segmentamos tu base de datos y reactivamos pacientes inactivos con campañas personalizadas y seguimiento automatizado.",
          bullets: [
            "Segmentación inteligente",
            "Campañas hiperpersonalizadas",
            "Seguimiento sin intervención",
          ],
        },
      ],
    },
    process: {
      eyebrow: "Cómo funciona",
      title: "Cuatro pasos. Cero fricción.",
      steps: [
        {
          n: "01",
          name: "Diagnóstico",
          desc: "Analizamos tu clínica, tu software y tus métricas en una llamada de 30 minutos.",
        },
        {
          n: "02",
          name: "Diseño",
          desc: "Te entregamos un plan personalizado con flujos de automatización y proyección de retorno.",
        },
        {
          n: "03",
          name: "Implementación",
          desc: "Configuramos todo en 7 días. Tu equipo no toca nada durante el proceso.",
        },
        {
          n: "04",
          name: "Optimización",
          desc: "Medimos, ajustamos y crecemos contigo cada mes. Reporting transparente.",
        },
      ],
    },
    testimonials: {
      eyebrow: "Confiado por clínicas",
      title: "Lo que dicen nuestros pacientes... perdón, clientes.",
      items: [
        {
          quote:
            "Recuperamos 134 pacientes en el primer trimestre. La inversión se pagó sola en seis semanas.",
          name: "Dr. Carlos Mendoza",
          role: "Director, Clínica Mendoza · Madrid",
        },
        {
          quote:
            "Pasamos de un 22% de ausencias a un 6%. Mi equipo por fin puede centrarse en los pacientes que están en el sillón.",
          name: "Dra. Elena Ruiz",
          role: "Propietaria, Sonrisas Ruiz · Valencia",
        },
      ],
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Lo que sueles preguntarnos antes de empezar.",
      items: [
        {
          q: "¿Funciona con mi software de gestión actual?",
          a: "Sí. Integramos con los principales softwares dentales del mercado español (Klinikare, Gesden, Odontonet, Klinic Cloud y otros). Si usas uno distinto, lo evaluamos en la llamada de diagnóstico.",
        },
        {
          q: "¿Cuánto tiempo tarda en estar funcionando?",
          a: "El despliegue estándar es de 7 días laborables. Tu equipo no tiene que parar consultas en ningún momento.",
        },
        {
          q: "¿Hay permanencia?",
          a: "No. Trabajamos con contratos mensuales. Si no funciona, lo cancelas. Punto.",
        },
        {
          q: "¿Es legal en España (RGPD)?",
          a: "Totalmente. Cumplimos RGPD y LOPDGDD. Firmamos contrato de tratamiento de datos y todo el procesamiento se hace en servidores de la UE.",
        },
        {
          q: "¿Qué pasa con los datos de mis pacientes?",
          a: "Son tuyos. Siempre. Nosotros solo procesamos lo necesario para automatizar, nunca vendemos ni compartimos información con terceros.",
        },
      ],
    },
    contact: {
      eyebrow: "Hablemos",
      title: "Reserva tu demo o escríbenos.",
      subtitle:
        "30 minutos. Sin compromiso. Te enseñamos exactamente cómo se vería tu clínica con nuestros sistemas.",
      tabBook: "Reservar demo",
      tabContact: "Enviar mensaje",
      form: {
        name: "Nombre",
        email: "Email",
        phone: "Teléfono",
        clinic: "Nombre de la clínica",
        message: "Cuéntanos en qué podemos ayudarte",
        notes: "Notas (opcional)",
        date: "Elige una fecha",
        time: "Elige una hora",
        submitBook: "Confirmar demo",
        submitContact: "Enviar mensaje",
        successBook: "¡Demo reservada! Te enviaremos un email de confirmación.",
        successContact: "¡Mensaje enviado! Te respondemos en menos de 24h.",
        error: "Algo ha ido mal. Inténtalo de nuevo.",
        selectDate: "Selecciona una fecha primero",
        timeTaken: "Hora no disponible",
      },
    },
    footer: {
      tagline: "Automatización con IA para clínicas dentales en España.",
      legal: "Todos los derechos reservados.",
      contact: "Contacto",
    },
  },
  en: {
    nav: {
      services: "Services",
      process: "How it works",
      results: "Results",
      faq: "FAQ",
      contact: "Contact",
      bookDemo: "Book a demo",
      bookShort: "Book",
    },
    hero: {
      eyebrow: "AI automation agency",
      title1: "Your dental clinic,",
      title2: "always booked.",
      subtitle:
        "We help dental clinics recover thousands of euros per month by preventing cancellations, no-shows and reactivating inactive patients.",
      ctaPrimary: "Book a free demo",
      ctaSecondary: "See services",
      microPoint1: "No lock-in",
      microPoint2: "Live in 7 days",
      microPoint3: "Spanish-speaking support",
    },
    stats: {
      eyebrow: "Measurable results",
      title: "Designed to generate ROI from month one.",
      items: [
        { value: "+47%", label: "Patients recovered" },
        { value: "−68%", label: "No-shows" },
        { value: "24/7", label: "Automated care" },
        { value: "5×", label: "Average ROI" },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Three systems. One clinic that runs itself.",
      subtitle:
        "We integrate each solution with your current management software. No painful migrations.",
      items: [
        {
          tag: "01",
          name: "AI Chatbot",
          short: "Handles WhatsApp and web 24/7.",
          desc: "An assistant trained on your clinic that answers FAQs, qualifies patients and books appointments automatically.",
          bullets: [
            "WhatsApp Business integration",
            "Automated bookings",
            "Smooth human handoff",
          ],
        },
        {
          tag: "02",
          name: "Appointment automation",
          short: "Reminders that crush no-shows.",
          desc: "Smart confirmations, reminders and reschedules via SMS, email and WhatsApp. Forget the empty slot.",
          bullets: [
            "Multichannel reminders",
            "One-click confirmation",
            "Auto-rescheduling",
          ],
        },
        {
          tag: "03",
          name: "Patient recovery",
          short: "Refill your schedule with people who already trust you.",
          desc: "We segment your database and re-engage inactive patients with personalized campaigns and automated follow-ups.",
          bullets: [
            "Smart segmentation",
            "Hyper-personalized campaigns",
            "Hands-off follow-ups",
          ],
        },
      ],
    },
    process: {
      eyebrow: "How it works",
      title: "Four steps. Zero friction.",
      steps: [
        {
          n: "01",
          name: "Discovery",
          desc: "We analyze your clinic, your software and your metrics in a 30-minute call.",
        },
        {
          n: "02",
          name: "Design",
          desc: "You receive a custom plan with automation flows and projected ROI.",
        },
        {
          n: "03",
          name: "Implementation",
          desc: "Live in 7 days. Your team doesn't touch a thing during setup.",
        },
        {
          n: "04",
          name: "Optimization",
          desc: "We measure, tune and grow with you every month. Transparent reporting.",
        },
      ],
    },
    testimonials: {
      eyebrow: "Trusted by clinics",
      title: "What our patients... sorry, clients say.",
      items: [
        {
          quote:
            "We recovered 134 patients in the first quarter. The investment paid for itself in six weeks.",
          name: "Dr. Carlos Mendoza",
          role: "Director, Clínica Mendoza · Madrid",
        },
        {
          quote:
            "We went from 22% no-shows to 6%. My team can finally focus on the patient in the chair.",
          name: "Dr. Elena Ruiz",
          role: "Owner, Sonrisas Ruiz · Valencia",
        },
      ],
    },
    faq: {
      eyebrow: "Frequently asked",
      title: "The questions you usually ask before starting.",
      items: [
        {
          q: "Does it work with my current management software?",
          a: "Yes. We integrate with the main Spanish dental software (Klinikare, Gesden, Odontonet, Klinic Cloud and others). If you use a different one, we'll check it during the discovery call.",
        },
        {
          q: "How long until it's running?",
          a: "Standard rollout is 7 business days. Your team never has to pause patient care.",
        },
        {
          q: "Is there a lock-in contract?",
          a: "No. We work month-to-month. If it doesn't work, you cancel. Period.",
        },
        {
          q: "Is it GDPR compliant?",
          a: "Fully. We comply with GDPR and Spanish LOPDGDD. We sign a Data Processing Agreement and all processing happens on EU servers.",
        },
        {
          q: "What happens to my patient data?",
          a: "It's yours. Always. We only process what's strictly needed for automation. We never sell or share data with third parties.",
        },
      ],
    },
    contact: {
      eyebrow: "Let's talk",
      title: "Book your demo or drop us a line.",
      subtitle:
        "30 minutes. No strings attached. We'll show you exactly how your clinic would look running on our systems.",
      tabBook: "Book a demo",
      tabContact: "Send a message",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        clinic: "Clinic name",
        message: "Tell us how we can help",
        notes: "Notes (optional)",
        date: "Pick a date",
        time: "Pick a time",
        submitBook: "Confirm demo",
        submitContact: "Send message",
        successBook: "Demo booked! We'll send a confirmation email.",
        successContact: "Message sent! We'll get back to you in under 24h.",
        error: "Something went wrong. Please try again.",
        selectDate: "Pick a date first",
        timeTaken: "Time not available",
      },
    },
    footer: {
      tagline: "AI automation for dental clinics in Spain.",
      legal: "All rights reserved.",
      contact: "Contact",
    },
  },
};

const I18nContext = createContext({ lang: "es", t: translations.es, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
    return stored === "en" || stored === "es" ? stored : "es";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = { lang, t: translations[lang], setLang };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
